import React from 'react';
import { NavLink } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import Helmet from 'react-helmet';
import Breadcrumbs from '../../components/Breadcrumbs';
import chevronPng from '../../components/images/chevron_black.png';
import chevronSvg from '../../components/images/chevron_black.svg';
import styles from './index.sass';

class CategoryListContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(store, navConfig) {
    let description = `${navConfig.text} – ${store.name}`;
    let title = description;
    return {
      title: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:url', content: this.props.currentRoute.absolute_url},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description}
      ]
    };
  }

  renderCategories(navConfig) {
    let parentLinkProps = {
      className: styles.parent
    };
    let childLinkProps = {
      className: styles.child
    };
    return (navConfig.children || []).map((link) => {
      let parentLink;
      if(link.text) {
        let chevron = link.url ? <img src={chevronSvg} /> : null;
        parentLink = (
          <li>
            <NavLink href={link.url} {...parentLinkProps}>{link.text} {chevron}</NavLink>
          </li>
        );
      }
      let childLinks = [];
      if(link.children) {
        childLinks = link.children.map((childLink) => {
          return (
            <li key={childLink.url}>
              <NavLink href={childLink.url} {...childLinkProps}>{childLink.text}</NavLink>
            </li>
          );
        });
      }
      return (
        <ul key={link.url} className={styles.subCategoryLinks}>
          {parentLink}
          {childLinks}
        </ul>
      );
    });
  }

  render() {
    let { store, currentRoute } = this.props;
    let breadcrumbsProps = {
      className: styles.breadcrumbs,
      links: [{routeName: 'storeLandingPage'}]
    };
    let navConfig = store.navigation.find((config) => {
      return config.url === currentRoute.url;
    });
    // TODO: 404?
    if(!navConfig) {return <section className={styles.container} />;}

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(store, navConfig)} />
        <Breadcrumbs {...breadcrumbsProps} />
        <h1 className={styles.title}>{navConfig.text}</h1>
        <div className={`${styles.categories} ${(navConfig.children && navConfig.children.length) === 1 ? styles.maxHeight : ''}`}>
          {this.renderCategories(navConfig)}
        </div>
      </section>
    );
  }
}

export default CategoryListContainer;



// WEBPACK FOOTER //
// banquet/containers/CategoryListContainer/index.js